<template lang="pug">
include templates/SmartButton.pug
+wrapper({ type: 'fallback'})
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { SmartButtonMixin } from '@/host/components/mixins/SmartButton'

export default {
  name: 'FallbackSmartButton',
  mixins: [SmartButtonMixin],
  data() {
    return {
      brands: '',
      brandFilter: '',
      isFallback: true
    }
  },
  computed: {
    ...mapGetters(['isFormReady']),
    paymentMethod() {
      return this.paymentMethods[0]
    },
    /**
     * It will be visible only when there is one
     * payment method declared in the DNA and it's not an integrated
     * cards form
     */
    isVisible() {
      return this.isFallbackSmartButtonVisible
    },
    isSelected() {
      return true
    },
    showAmount() {
      return !this.hasCustomLabelWithAmount
    },
    hasRegularLabel() {
      return this.shortMethodKey !== 'CARDS' && !this.showLoadingAnimation
    },
    hasSingleBrand() {
      return false
    },
    hasCustomLabelWithAmount() {
      return false
    },
    singleBrandLabel() {
      return ''
    },
    methodLabel() {
      return this.defaultMethodLabel
    },
    regularMethodLabel() {
      return (
        this.getCustomPaymentMethodLabel(this.cleanPaymentMethod) ||
        this.methodLabel
      )
    },

    displayedBrands() {
      return this.effectiveCardBrandList
    },
    mainFormReady() {
      return this.isFormReady('default')
    }
  },
  watch: {
    mainFormReady(val) {
      // @see KJS-4971 - Fallback SB is artificially auto selected visually, but
      // the method is not considered as selected in store.
      //
      // @see KJS-5139 - Need to trigger method selection after the main form is ready
      // As the loading of new embedded card forms (i.e. ILLICADO) breaks the synchronization
      //
      if (val && this.showRadioButton && this.isVisible)
        this.selectMethod(this.paymentMethod)
    }
  },
  methods: {
    ...mapActions(['selectMethod'])
  }
}
</script>
